import axios from "axios";
import { useEffect, useState } from "react";
import { appAddress } from "../App";


function TeamAPI(){
    const [team, setTeam] = useState([]);
    const [callback, setCallback] = useState(false)

    useEffect(()=> {
        const getTeam = async () => {
            const res = await axios.get(`${appAddress}/api/Team`)
            // const res = await axios.get('/api/team')

            setTeam(res.data)
        }

        getTeam()
    },[callback])

    return {
        team: [team, setTeam],
        callback: [callback, setCallback]
    }
}

export default TeamAPI